import PubSub from "pubsub-js";

var ListingUnits = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-ListingUnits',
  };

  $.extend(true, this.options, options);

};

ListingUnits.prototype.init = function () {

  var self = this;

  this.$availableListings = this.options.$el.find(`[data-open-modal-unit-details]`);

  this.$availableListings.on('click', function () {

    var unitId = $(this).data('open-modal-unit-details');

    self.showUnitModal(unitId);

  });

  // if unit url parameter exists, open modal on page load
  var currentUrl = window.location.href;

  if (currentUrl.indexOf("unitDetail")) {

    var urlSegments = currentUrl.split('?');

    if (urlSegments.length > 1) {

      var urlParameters = urlSegments[1].split('&');

      for (var i = 0; i < urlParameters.length; i++) {

        if (urlParameters[i].indexOf("unitDetail") == 0) {

          var unitId = urlParameters[i].split('=')[1];

          // make sure we don't open our modal onload from multiple components
          if (!window.unitDetailOpenedOnload) {
            console.log('ListingUnits:showmodal');
            window.unitDetailOpenedOnload = true;
            self.showUnitModalWhenLoaded(unitId);
          }

        }

      }

    }

  }

};

ListingUnits.prototype.showUnitModalWhenLoaded = function (unitId) {

  var self = this;

  if (!window.modalUnitDetailLoaded) {
    setTimeout(function () {
      self.showUnitModalWhenLoaded(unitId);
    }, 50);

  } else {

    self.showUnitModal(unitId);

  }

};

ListingUnits.prototype.showUnitModal = function (unitId) {

  var self = this;

  // open up the modal in loading state
  PubSub.publish('ModalUnitDetail:open', unitId);

  // put together our graph ql query
  var query = `
	query MyQuery {
		entry(section: "units", id: "` + unitId + `") {
			... on units_unit_Entry {
				id
				url
				unitActive
				unitBeds
				unitBaths
				unitSquareFeet
				unitCost
				unitFixedCharges
				unitTotalRent
				unitNote
				title
				unitIntroText
				unitApplicationFee
				unitSecurityDeposit
				unitPetPolicies {
					... on unitPetPolicies_petPolicy_BlockType {
						petPolicyText
					}
				}
				unitAvailability
				unitAmenities {
					... on unitAmenities_amenity_BlockType {
						amenityText
					}
				}
				unitApplyUrl
				unitYoutubeVideoId
				unitImages {
				  	url @transform(width: 960, height: 540, immediately: true)
				}
				unitFloorPlan {
					... on floorPlans_floorPlan_Entry {
						id
						floorPlanBeds
						floorPlanBaths
						floorPlanSquareFeet
						floorPlanImage {
							url
						}
					}
				}
			}
		}
	}
	`;

  // run the ajax query that gets our unit data
  $.ajax({

    type: 'POST',
    url: '/api',
    data: {
      query: query
    },

    success: function (data) {

      if (!data.data.entry) {
        PubSub.publish('ModalUnitDetail:notFound');
        return;
      }

      PubSub.publish('ModalUnitDetail:populateContent', data.data.entry);

    },

    error: function (data) {
      console.log('ajax error');
      console.log(data);
    },

  });

};

export default ListingUnits;